import 'babel-polyfill'
import Vue from "vue";
import App from "./App";
import router from "./router";
import store from "./store";
import fetch from "./plugins/fetch";
import scroll from "./components/better_scroll.vue";
import VueLeave from "./lib/index";
import Antd from "ant-design-vue";
import "ant-design-vue/dist/antd.css";

import Toast from "@/components/toast/toast";
import Privacy from "@/components/privacy_policy";
// 弹出框
import Dialog from "@/components/Dialog";

import "./assets/font/iconfont.css";
import "./assets/sass/global.scss";
import "./assets/js/rem.js";
import commonFunc from "@/assets/js/base.js";
import Common from "./mixins";
// 弹窗时静止默认滚动事件
import ModalHelper from "@/lib/util";
import i18n from "./api/i18n";
// 支持图片缩放
import Viewer from 'v-viewer'
import 'viewerjs/dist/viewer.css'
Vue.use(Viewer)
Viewer.setDefaults({
  // 需要配置的属性 注意属性并没有引号
  title: false,
  toolbar: false,
  viewed() {
    this.viewer.zoom(0.5)
  },
})
// 懒加载
import VueLazyload from "vue-lazyload";
import xss from "xss";
var options = {
  onTag: function (tag, html) {
    if (html === "<i>") {
      return '<i style="font-style: italic;">';
    }
    if (tag === "p") {
      return html;
    }
  },
  onIgnoreTag: function (tag, html) {
    if (tag === "strike") {
      return html;
    }
  },
};
Object.defineProperty(Vue.prototype, "$xss", {
  value: (html) => {
    return xss(html, options);
  },
});
// import layer from "vue-layer";
// Vue.prototype.$layer = layer(Vue, {
//   msgtime: 2, // 消失时间
// });
Vue.prototype.$toast = Toast;
Vue.use(Privacy);
Vue.use(Dialog);
Vue.use(fetch, scroll, VueLeave);
Vue.use(Antd);
// promise.polyfill()
Vue.prototype.$modalHelper = ModalHelper;

Date.prototype.Format = function (fmt) {
  var o = {
    "M+": this.getMonth() + 1, // 月份
    "d+": this.getDate(), // 日
    "h+": this.getHours(), // 小时
    "m+": this.getMinutes(), // 分
    "s+": this.getSeconds(), // 秒
    "q+": Math.floor((this.getMonth() + 3) / 3), // 季度
    S: this.getMilliseconds(), // 毫秒
  };
  if (/(y+)/.test(fmt)) {
    fmt = fmt.replace(RegExp.$1, this.getFullYear() + "");
  }
  for (var k in o) {
    if (new RegExp("(" + k + ")").test(fmt))
      fmt = fmt.replace(
        RegExp.$1,
        RegExp.$1.length == 1 ? o[k] : ("00" + o[k]).substr(("" + o[k]).length)
      );
  }
  return fmt;
};
Vue.mixin(Common);
Vue.use(VueLazyload);
Vue.use(commonFunc);
Vue.config.productionTip = false;
new Vue({
  i18n,
  store,
  router,
  render: (h) => h(App),
}).$mount("#app");
